import * as Config from './config';
import * as Profile from './profile';
import * as Contact from './contact';
import * as UserConfig from './user-config';
export const Container = {
    models: {
        config: Config.Options,
        profile: Profile.Options,
        contact: Contact.Options,
        userConfig: UserConfig.Options
    }
};
